import { Skeleton as MuiSkeleton, Stack as MuiStack } from "@mui/material";
import { Theme } from "common";
import StudyRecruitmentInstructions from "./StudyRecruitmentInstructions";
import StudyRecruitmentFormContainer from "./StudyRecruitmentFormContainer";
import { LOADER_TYPES } from "app/services/StudyRecruitmentService/constants";
import { useStudyRecruitment } from "app/services/StudyRecruitmentService/StudyRecruitmentProvider";

const boxStyles = {
  padding: "16px",
  backgroundColor: Theme.palette.primary.contrastText,
  borderRadius: "8px",
  boxShadow: "rgba(0, 0, 0, 0.1) 1px 1px 3px 0.2px ",
  width: "1150px",
};

const StudyRecruitmentContainer = () => {
  const { isLoading, userPerms, protocolNumber, studies } =
    useStudyRecruitment();
  // Only gate the page shell on what routing/authorization needs. Each section
  // below gates itself on its own API so it can render as soon as it is ready.
  const loading =
    isLoading[LOADER_TYPES.STUDIES] ||
    !protocolNumber ||
    (studies.length === 0 && !userPerms.canViewStudyRecruitment);

  return (
    <MuiStack id="pep-study-recruitment-home" gap={2.5}>
      <StudyRecruitmentInstructions />

      {loading ? (
        <MuiStack gap={2} sx={boxStyles}>
          <MuiSkeleton variant="rounded" width={1114} height={38.25} />

          <MuiStack alignItems="flex-start" direction="row" gap={2}>
            <MuiSkeleton variant="rounded" width={268} height={421} />

            <MuiStack gap={2}>
              <MuiSkeleton variant="rounded" width={834} height={124} />
              <MuiSkeleton variant="rounded" width={834} height={815} />
            </MuiStack>
          </MuiStack>
        </MuiStack>
      ) : (
        <StudyRecruitmentFormContainer />
      )}
    </MuiStack>
  );
};

export default StudyRecruitmentContainer;
